const capitalizeFirstLetter = ([first, ...rest]: string, locale: string = navigator.language): string => (
    [first.toLocaleUpperCase(locale), ...rest].join('')
);

const variableToLabel = (variableName: string): string => (
    capitalizeFirstLetter(variableName.split(/(?=[A-Z])/).join(' ').toLowerCase())
);

const pluralize = (word: string): string => (word.slice(-1) === 's' ? word : `${word}s`);

const truncate = (word: string, maxLength: number, truncateLength: number = 3): string => {
    if (word.length > maxLength) {
        return `${word.slice(0, maxLength - truncateLength)}...`;
    }

    return word;
};

export {
    capitalizeFirstLetter,
    variableToLabel,
    pluralize,
    truncate,
};
